class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.dismissedThisVisit = this.isDismissedThisVisit();

    if (this.hasSubscription || this.dismissedThisVisit) return;

    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    this.closeBtn.addEventListener("click", (event) => {
      event.preventDefault();
      this.popup.classList.add("hidden");
      this.markDismissedThisVisit();
    });
  }

  isDismissedThisVisit() {
    try {
      return sessionStorage.getItem("hideNotificationPopup") === "true";
    } catch (e) {
      return false;
    }
  }

  markDismissedThisVisit() {
    try {
      sessionStorage.setItem("hideNotificationPopup", "true");
    } catch (e) {}
  }
}

customElements.define("notification-popup", NotificationPopup);
